import * as go from 'gojs';
import { IMAGE_SOURCE_PROP } from '../config/image-node-prop-names';

export const imageSourceBinding = () => new go.Binding('source', IMAGE_SOURCE_PROP);
